module.exports = __webpack_public_path__ + "static/ProfileTaylor-c6ffd4af1c38edcf96e8553b707d648b.jpg";